import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { LoggingService } from 'app/wipperoz-core/services/logging.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ResourcesService } from '../services/resources.service';

@Component({
  selector: 'app-unsubscribe-email',
  templateUrl: './unsubscribe.component.html',
  styleUrls: ['./unsubscribe.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UnsubscribeComponent implements OnInit, OnDestroy {
  confirmationText = '';
  unsubscribed = false;
  working = false;

  wipperozLogo =
    'https://cdn.sanity.io/images/jizm7zxy/production/eca04a468bb51fd5165d6e25cd62302a3aa3cf7e-300x117.png?fm=webp&q=90&w=200';
  bannerBGImage = `https://cdn.sanity.io/images/jizm7zxy/production/bd01c9767ce4180bd7290dbee6d4257d0ff5e7ed-1920x1080.png?fm=webp&q=90`;

  private unsubscribeAll: Subject<any>;

  constructor(
    private route: ActivatedRoute,
    private resourcesService: ResourcesService,
    private loggingService: LoggingService
  ) {
    this.unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this.init();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
  }

  private init(): void {
    this.route.queryParams.pipe(takeUntil(this.unsubscribeAll)).subscribe((params: Params) => {
      if (params['userId'] !== undefined && params['alertType'] !== undefined) {
        this.resourcesService
          .unsubscribeFromNotification(params)
          .then((data) => {
            this.confirmationText = $localize`:@@unsubscritionSuccessfulMessage:You have been unsubscribed from the requested notifications!`;
            this.unsubscribed = data.body.unsubscribed;
            this.working = false;
          })
          .catch((err) => {
            this.loggingService.logError('unsubscribe init error', JSON.stringify(err));
            this.confirmationText = $localize`:@@unsubscritionErrorMessage:Something wrong happened, please try again later!`;
            this.unsubscribed = false;
            this.working = false;
          });
      }
    });
  }
}
